import { Footer } from '@web/timesheets/CreateTimesheetModal/components/CreateTimesheetModalFooter/createTimesheetModalFooter.styles';
import CloseTimesheetFooterButton from '@web/timesheets/TimesheetViewModal/components/TimesheetViewModalFooter/CloseTimesheetFooterButton';
import SaveTimesheetFooterButton from '@web/timesheets/CreateTimesheetModal/components/CreateTimesheetModalFooter/SaveTimesheetFooterButton';

type Props = {
  onClose: VoidFunction;
  onSave: () => Promise<void>;
  canSubmit: boolean;
};
const CreateTimesheetModalFooter = ({ onClose, onSave, canSubmit }: Props) => (
  <Footer>
    <CloseTimesheetFooterButton onClose={onClose} />
    <SaveTimesheetFooterButton onSave={onSave} canSubmit={canSubmit} />
  </Footer>
);

export default CreateTimesheetModalFooter;
